import * as React from "react";
import type { SVGProps } from "react";
const SvgIconCross = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.07 1.6c-.23.04-.43.24-.47.47q-.02.18.05.34c.03.06.6.65 2.79 2.83L7.19 8l-2.75 2.76c-2.19 2.18-2.76 2.77-2.8 2.83-.1.21-.05.48.12.65s.44.21.65.11c.06-.03.66-.61 2.83-2.79L8 8.81l2.76 2.75c2.18 2.18 2.77 2.76 2.83 2.8.21.1.48.05.65-.12s.21-.44.11-.65c-.03-.06-.61-.66-2.79-2.83L8.81 8l2.75-2.76c2.18-2.17 2.76-2.77 2.79-2.83.1-.21.06-.48-.11-.65s-.44-.21-.65-.11c-.06.03-.65.6-2.83 2.79L8 7.19 5.25 4.45c-1.5-1.51-2.77-2.76-2.8-2.78q-.17-.1-.38-.07"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconCross;
